import { useEffect } from "react";

export function useClickOutside(ref, handler) {
  useEffect(() => {
    function listener(event) {
      // Do nothing if clicking/ref is null or click inside the element
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    }

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener); // for mobile

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
